// Phase 6C · AI Studio Drafts — frontend API client. Additive.
import axios from "axios";
import { API } from "@/contexts/AuthContext";

const BASE = `${API}/ai-studio/drafts`;

export async function listDrafts() {
  const { data } = await axios.get(`${BASE}`);
  return data?.items || [];
}

export async function getDraft(id) {
  const { data } = await axios.get(`${BASE}/${id}`);
  return data;
}

export async function composeDraft({
  title, kind = "text", prompt,
  source_entity_type = "manual", source_entity_id = null,
  use_brand_kit = false,
}) {
  const { data } = await axios.post(`${BASE}`, {
    title, kind, prompt,
    source_entity_type, source_entity_id, use_brand_kit,
  });
  return data;
}

export async function regenerateDraft(id, { prompt } = {}) {
  const { data } = await axios.post(`${BASE}/${id}/regenerate`,
    prompt ? { prompt } : {});
  return data;
}

export async function approveDraft(id) {
  const { data } = await axios.post(`${BASE}/${id}/approve`);
  return data;
}

export async function deleteDraft(id) {
  await axios.delete(`${BASE}/${id}`);
}
